/** Runtime config injected by /config.js (see public/config.js); falls back to Vite env / defaults. */
type ArgoConfig = { apiBase?: string; oidcAuthority?: string; oidcClientId?: string; auth?: 'oidc' | 'off' }
declare global { interface Window { ARGO_CONFIG?: ArgoConfig } }

const w = typeof window !== 'undefined' ? window.ARGO_CONFIG ?? {} : {}
export const config = {
  apiBase: w.apiBase ?? (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api',
  oidcAuthority: w.oidcAuthority ?? (import.meta.env.VITE_OIDC_AUTHORITY as string | undefined) ?? 'http://localhost:8180/realms/argo',
  oidcClientId: w.oidcClientId ?? (import.meta.env.VITE_OIDC_CLIENT_ID as string | undefined) ?? 'argo-web',
  auth: w.auth ?? ((import.meta.env.VITE_AUTH as string | undefined) === 'off' ? 'off' : 'oidc'),
}
